import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClienteMicrosegRepository } from 'src/app/domain/service/cliente-microseg/cliente-microseg-repository';
import { ClienteMicroseg } from '@model/cliente-microseg/cliente-microseg';

/**
 * Adaptador HTTP: HttpClienteMicrosegRepository
 *
 * Implementa el puerto ClienteMicrosegRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (ClienteMicrosegController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto ClienteMicrosegRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpClienteMicrosegRepository implements ClienteMicrosegRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/microsegmentaciones`;

  async obtenerMicrosegmentaciones(nmconsecutivoCliente: number): Promise<ClienteMicroseg[]> {
    const params = new HttpParams().set('nmconsecutivoCliente', nmconsecutivoCliente.toString());
    return firstValueFrom(
      this.http.get<ClienteMicroseg[]>(this.baseUrl, { params })
    );
  }
}
